export default __webpack_public_path__ + "static/media/rnr-sports-table-6-cn.d9a227fe.webp";